import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE || 'https://api.rabbitidx.com';

const client = axios.create({
    baseURL,
    withCredentials: false,
    headers: { Accept: 'application/json' },
});

export default function useApi() {
    ////////////////////////////////////////////////////////////////////
    /// Fetch the public, active tutorials for a surface (default website).
    const loadTutorials = async (surface = 'website') => {
        const { data } = await client.get('/api/tutorials', { params: { surface } });
        return data;
    };

    return { loadTutorials };
}
